import React, { useEffect, useState } from 'react';
import { useContent } from '../contexts/ContentContext';
import { fetchPopularImages, ImageMetadata } from '../services/api';
import { illustrationUrl } from '../utils/illustrationRoute';
import ExploreSection from './ExploreSection';
import ImageGrid from './ImageGrid';

export default function PopularImagesSection({ home = false }: { home?: boolean }) {
    const { t } = useContent();
    const [result, setResult] = useState<{ items: ImageMetadata[]; total: number } | null>(null);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const controller = new AbortController();
        setResult(null); setError(false);
        const query = new URLSearchParams({ per_page: '10' });
        if (home) query.set('min_score', '0');
        fetchPopularImages(query, controller.signal)
            .then(value => { if (!controller.signal.aborted) setResult({ items: value.items, total: value.pagination.total_items }); })
            .catch(() => { if (!controller.signal.aborted) setError(true); });
        return () => controller.abort();
    }, [home, attempt]);
    return <ExploreSection root="popular" title={t('illustrations.popular') + (!home && result ? ` (${result.total})` : '')}
        href={illustrationUrl('popular')} className="lab-popular-images"
        footerContent={!home && result && !error && <div className="lab-illustration-section__more">
            {result.items.length === result.total ? <button type="button" className="lab-button" disabled>{t('illustrations.allShown')}</button>
                : <a className="lab-button" href={illustrationUrl('popular')}>{t('illustrations.showAll')}</a>}
        </div>}>
        {expanded => error ? <div role="alert"><p>{t('search.error')}</p><button type="button" className="lab-button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></div>
            : !result ? <p role="status">{t('common.loading')}</p>
            : !result.items.length ? <p>{t('home.empty')}</p>
            : <ImageGrid images={result.items} year={null} month={null} showMonthNavigation={false}
                contextHref={home ? '/?' : undefined}
                idPrefix={`preview-popular-${home ? 'home' : 'ai'}-${expanded ? 'expanded-' : ''}`} />}
    </ExploreSection>;
}
